import type { TemplateContentScores } from '@marketing-hub/shared';
import campStyles from '@/features/campaigns/Campaigns.module.css';

type Props = {
  scores: TemplateContentScores;
  showBacklinkHint?: boolean;
};

function chipClass(level: 'good' | 'warn' | 'bad'): string {
  if (level === 'good') return campStyles.scoreChipGood;
  if (level === 'warn') return campStyles.scoreChipWarn;
  return campStyles.scoreChipBad;
}

export function EmailTemplateScoreChips({ scores, showBacklinkHint }: Props) {
  const readLevel =
    scores.readability === 'good' ? 'good' : scores.readability === 'ok' ? 'warn' : 'bad';
  const spamLevel =
    scores.spam_risk === 'low' ? 'good' : scores.spam_risk === 'medium' ? 'warn' : 'bad';

  return (
    <div className={campStyles.scoreChipRow} aria-label="Template scores">
      <span className={`${campStyles.scoreChip} ${chipClass(readLevel)}`}>
        {scores.word_count} woorden ·{' '}
        {scores.readability === 'good'
          ? 'Leesbaar'
          : scores.readability === 'ok'
            ? 'Matig lang'
            : 'Lang'}
      </span>
      <span className={`${campStyles.scoreChip} ${chipClass(spamLevel)}`}>
        Spam {scores.spam_risk}
        {scores.spam_hits.length ? ` (${scores.spam_hits.slice(0, 2).join(', ')})` : ''}
      </span>
      <span className={campStyles.scoreChip}>
        Onderwerp {scores.subject_length} tekens
      </span>
      {showBacklinkHint && scores.backlink_touch0_ok != null ? (
        <span
          className={`${campStyles.scoreChip} ${scores.backlink_touch0_ok ? chipClass('good') : chipClass('warn')}`}
        >
          Backlink touch-0 {scores.backlink_touch0_ok ? 'OK' : 'Te lang'}
        </span>
      ) : null}
    </div>
  );
}
